export const INPUTS = {
    TOKEN_A: "tokenA",
    TOKEN_B: "tokenB"
}

export const Bound = {
    LOWER : 'LOWER',
    UPPER : 'UPPER'
}